// EMYASA locale and services-page compatibility fixes.
(() => {
  const fallbackScriptUrl =
    document.currentScript?.src ||
    Array.from(document.scripts).find((script) => script.src.includes('emy-english-fallback.js'))?.src ||
    '';

  const themeAssetUrl = (filename) => {
    if (!fallbackScriptUrl) return '';
    return fallbackScriptUrl.replace(/emy-english-fallback\.js(?:\?.*)?$/, filename);
  };

  const injectServicesLayoutStyles = () => {
    if (document.getElementById('emy-services-page-layout-fixes')) return;

    const style = document.createElement('style');
    style.id = 'emy-services-page-layout-fixes';
    style.textContent = `
      .emy-services-trust-logos {
        margin-block: clamp(30px, 4vw, 58px) clamp(46px, 5vw, 78px) !important;
      }

      .emy-services-trust-logos .section {
        padding-block: 0 !important;
      }

      .emy-services-trust-logos img {
        display: block;
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    `;
    document.head.appendChild(style);
  };

  const loadServicesCarouselAssets = () => {
    const cssUrl = themeAssetUrl('emy-services-expand-carousel.css');
    const jsUrl = themeAssetUrl('emy-services-expand-carousel.js');

    if (cssUrl && !document.querySelector('link[href*="emy-services-expand-carousel.css"]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
    }

    if (jsUrl && !document.querySelector('script[src*="emy-services-expand-carousel.js"]')) {
      const script = document.createElement('script');
      script.src = jsUrl;
      script.defer = true;
      document.head.appendChild(script);
    }
  };

  const restoreServicesPage = () => {
    const serviceSection = document.querySelector('[id$="__carousel_fdrYJm"]');
    if (!serviceSection) return false;

    const carousel =
      serviceSection.querySelector('[data-testid="carousel-section"]') ||
      serviceSection.querySelector('.section-carousel');

    if (carousel) {
      carousel.classList.add('emy-services-expand');
      carousel.setAttribute('data-emy-services-expand', '');
      loadServicesCarouselAssets();
    }

    const trustHeading = document.querySelector('[id$="__section_WbWkGk"]');
    const trustLogos = document.querySelector('[id$="__section_j6Btjm"]');

    if (trustHeading && trustLogos) {
      trustLogos.classList.add('emy-services-trust-logos');
      if (trustHeading.nextElementSibling !== trustLogos) {
        trustHeading.insertAdjacentElement('afterend', trustLogos);
      }
      injectServicesLayoutStyles();
    }

    return true;
  };

  let serviceFixFrame = 0;
  const scheduleServicesRestore = () => {
    if (serviceFixFrame) return;
    serviceFixFrame = window.requestAnimationFrame(() => {
      serviceFixFrame = 0;
      restoreServicesPage();
    });
  };

  const startServicesRestore = () => {
    restoreServicesPage();

    if ('MutationObserver' in window && document.body) {
      const observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.addedNodes.length > 0)) {
          scheduleServicesRestore();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', scheduleServicesRestore);
    document.addEventListener('shopify:section:reorder', scheduleServicesRestore);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startServicesRestore, { once: true });
  } else {
    startServicesRestore();
  }

  const locale = (document.documentElement.lang || '').toLowerCase();
  if (!locale.startsWith('en')) return;

  const translations = new Map([
    ['Ubicación estratégica', 'Strategic location'],
    ['Alcance global', 'Global reach'],
    ['A la frontera norte', 'To the northern border'],
    ['México', 'Mexico'],
    ['Cobertura nacional', 'Nationwide coverage'],
    ['Capacidad de exportación', 'Export capabilities'],
    ['45+ años', '45+ years'],
    ['de experiencia industrial', 'of industrial experience'],
    ['Número 1', 'No. 1'],
    ['En manufactura metálica del norte de México.', 'In metal manufacturing in northern Mexico.'],
    ['Alcance mundial', 'Global reach'],
    ['México y proyectos de exportación', 'Mexico and export projects'],
    ['Escala industrial', 'Industrial scale'],
    ['Desde surtido inicial hasta alto volumen', 'From initial stocking to high-volume orders'],
    ['PROGRAMA DE DISTRIBUIDORES', 'DISTRIBUTOR PROGRAM'],
    ['Distribución sin límites. Recursos para vender.', 'Limitless distribution. Resources to help you sell.'],
    ['Desde un primer surtido hasta pedidos de alto volumen. Recibe atención directa de fábrica y materiales comerciales para vender EMYASA en mostrador, ecommerce, marketplaces y cuentas corporativas.', 'From an initial stocking order to high-volume purchases. Receive direct factory support and sales materials to sell EMYASA in stores, e-commerce, marketplaces, and corporate accounts.'],
    ['Evaluar una alianza comercial', 'Explore a business partnership'],
    ['DISTRIBUCIÓN', 'DISTRIBUTION'],
    ['Compra a tu medida', 'Purchasing that fits your business'],
    ['Surtido inicial, reposición y pedidos de alto volumen.', 'Initial stocking, replenishment, and high-volume orders.'],
    ['Trato directo con fábrica', 'Direct factory support'],
    ['Cotización, disponibilidad y seguimiento sin intermediarios.', 'Quotes, availability, and follow-up without intermediaries.'],
    ['México y otros mercados', 'Mexico and international markets'],
    ['Cobertura nacional y evaluación de proyectos de exportación.', 'Nationwide coverage and evaluation of export projects.'],
    ['Condiciones para crecer', 'Terms designed for growth'],
    ['Propuesta comercial definida según el perfil, volumen y operación de cada distribuidor.', 'Commercial terms defined according to each distributor’s profile, volume, and operation.'],
    ['RECURSOS', 'RESOURCES'],
    ['Fotografías y videos', 'Photos and videos'],
    ['Contenido para catálogos, redes sociales y presentaciones comerciales.', 'Content for catalogs, social media, and sales presentations.'],
    ['Fichas técnicas', 'Technical data sheets'],
    ['Información clara para equipos de ventas, compras y cuentas corporativas.', 'Clear information for sales, purchasing, and corporate account teams.'],
    ['Ecommerce y marketplaces', 'E-commerce and marketplaces'],
    ['Recursos adaptables para publicar y presentar productos en canales digitales.', 'Adaptable assets for publishing and presenting products across digital channels.'],
    ['Visibilidad comercial', 'Market visibility'],
    ['Campañas y presencia en el mapa de distribuidores, de acuerdo con el perfil.', 'Campaign support and distributor map visibility based on the business profile.'],
    ['PROCESO CLARO', 'CLEAR PROCESS'],
    ['Así funciona la incorporación', 'How onboarding works'],
    ['PASO 01 · REGISTRO', 'STEP 01 · REGISTRATION'],
    ['Registra tu negocio', 'Register your business'],
    ['Comparte los datos de tu establecimiento, ubicación y necesidades comerciales.', 'Share your business details, location, and commercial needs.'],
    ['Completar registro', 'Complete registration'],
    ['PASO 02 · VALIDACIÓN', 'STEP 02 · REVIEW'],
    ['Validamos la información', 'We review your information'],
    ['Nuestro equipo revisará el perfil y se pondrá en contacto para conocer tu operación.', 'Our team reviews your profile and contacts you to learn more about your operation.'],
    ['Revisión comercial', 'Business review'],
    ['PASO 03 · ACTIVACIÓN', 'STEP 03 · ACTIVATION'],
    ['Empezamos a crecer juntos', 'We start growing together'],
    ['Una vez aprobado, coordinaremos pedidos, materiales y acciones de apoyo aplicables.', 'Once approved, we coordinate orders, materials, and applicable support initiatives.'],
    ['Activar beneficios', 'Activate benefits'],
    ['Ver más', 'View more'],
    ['Compra ahora', 'Shop now'],
    ['Empresas que ya confían en nosotros', 'Companies that already trust us'],
    ['ENVÍO GRATIS EN CAJAS', 'FREE SHIPPING ON CASE ORDERS'],
    ['5% DESDE 10 CAJAS · 10% DESDE 25 CAJAS', '5% OFF 10+ CASES · 10% OFF 25+ CASES'],
    ['Días', 'Days'],
    ['DÍA', 'DAY'],
    ['DÍAS', 'DAYS'],
    ['Horas', 'Hours'],
    ['HORA', 'HOUR'],
    ['HORAS', 'HOURS'],
    ['Minutos', 'Minutes'],
    ['MINUTO', 'MINUTE'],
    ['MINUTOS', 'MINUTES'],
    ['Segundos', 'Seconds'],
    ['SEGUNDO', 'SECOND'],
    ['SEGUNDOS', 'SECONDS'],
    ['POR TIEMPO LIMITADO:', 'LIMITED TIME:'],
    ['Por tiempo limitado:', 'Limited time:'],
    ['ENVÍO GRATIS', 'FREE SHIPPING'],
    ['ENVIO GRATIS', 'FREE SHIPPING'],
    ['Envío gratis', 'Free shipping'],
    ['EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 9% DESDE 25.', 'ON WHOLESALE CASES + 5% OFF 10+ CASES AND 9% OFF 25+ CASES.'],
    ['EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 9% DESDE 25 CAJAS.', 'ON WHOLESALE CASES + 5% OFF 10+ CASES AND 9% OFF 25+ CASES.'],
    ['EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 10% DESDE 25.', 'ON WHOLESALE CASES + 5% OFF 10+ CASES AND 10% OFF 25+ CASES.'],
    ['EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 10% DESDE 25 CAJAS.', 'ON WHOLESALE CASES + 5% OFF 10+ CASES AND 10% OFF 25+ CASES.'],
    ['POR TIEMPO LIMITADO: ENVÍO GRATIS EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 9% DESDE 25.', 'LIMITED TIME: FREE SHIPPING ON WHOLESALE CASES + 5% OFF 10+ CASES AND 9% OFF 25+ CASES.'],
    ['POR TIEMPO LIMITADO: ENVÍO GRATIS EN CAJAS DE MAYOREO + DESCUENTOS DEL 5% DESDE 10 CAJAS Y 10% DESDE 25 CAJAS.', 'LIMITED TIME: FREE SHIPPING ON WHOLESALE CASES + 5% OFF 10+ CASES AND 10% OFF 25+ CASES.'],
    ['Por tiempo limitado, las cajas completas de bombas de aire e inyectores de grasa EMYASA tienen', 'For a limited time, full cases of EMYASA air pumps and grease guns receive'],
    ['dentro de México.', 'within Mexico.']
  ]);

  const attributeTranslations = new Map([
    ['Alcance logístico de EMYASA', 'EMYASA logistics reach'],
    ['Respaldo y capacidad de EMYASA', 'EMYASA experience and capabilities'],
    ['Beneficios y recursos para distribuidores', 'Distributor benefits and sales resources'],
    ['Tiempo restante de la promoción', 'Time remaining in the promotion'],
    ['Ver más', 'View more']
  ]);

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const translateTextNode = (node) => {
    const original = node.nodeValue || '';
    const normalized = normalize(original);
    const translated = translations.get(normalized);
    if (!translated || translated === normalized) return;

    const leading = original.match(/^\s*/)?.[0] || '';
    const trailing = original.match(/\s*$/)?.[0] || '';
    node.nodeValue = `${leading}${translated}${trailing}`;
  };

  const translateAttributes = (element) => {
    ['aria-label', 'title', 'placeholder', 'value'].forEach((attribute) => {
      if (!element.hasAttribute?.(attribute)) return;

      const original = element.getAttribute(attribute) || '';
      const normalized = normalize(original);
      let translated = attributeTranslations.get(normalized) || translations.get(normalized);

      if (!translated && normalized.startsWith('Ver más:')) {
        translated = normalized.replace(/^Ver más:/, 'View more:');
      }

      if (translated && translated !== original) {
        element.setAttribute(attribute, translated);
      }
    });
  };

  const translateRoot = (root) => {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE) {
      const tag = root.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEMPLATE') return;
      translateAttributes(root);
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
          if (parent?.closest?.('script, style, noscript, template')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let current;
    while ((current = walker.nextNode())) {
      if (current.nodeType === Node.TEXT_NODE) translateTextNode(current);
      else translateAttributes(current);
    }
  };

  const startEnglishContentSync = () => {
    translateRoot(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(translateRoot);
        if (mutation.type === 'attributes') translateAttributes(mutation.target);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'placeholder', 'value']
    });

    document.addEventListener('shopify:section:load', (event) => translateRoot(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEnglishContentSync, { once: true });
  } else {
    startEnglishContentSync();
  }
})();
